import { LoaderIcon } from '@/components/ui/loader-icon';

export const LoadingPage = () => {
  return (
    <div className="h-full w-full grid place-content-center">
      <LoaderIcon />
    </div>
  );
};
